import { TokenType } from "../../enum/token-type.enum";
import { TokenCategory } from "../../enum/token-category.enum";

export class Token {
    constructor(
        public value: string, 
        public type: TokenType = TokenType.Time, 
        public category: TokenCategory = TokenCategory.Simple
    ){ }
}